import { RouteConfig } from 'vue-router';
import Rentalcars from '@/views/rentalcars/Overview.vue';
import RentalCarNew from '@/views/rentalcars/RentalCarNew.vue';
import RentalCarEdit from '@/views/rentalcars/RentalCarEdit.vue';
import RentalCarContractReturn from '@/views/rentalcarcontract/RentalCarContractReturn.vue';
import RentalCarContractReturnForm from '@/components/rentalcarcontract/forms/RentalCarContractReturnForm.vue';
import RentalCarPricing from '@/views/rentalcars/RentalCarPricing.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/rentalcars',
		name: 'rentalcars',
		component: Rentalcars,
	},
	{
		path: '/rentalcars/new',
		name: 'RentalCarNew',
		component: RentalCarNew,
	},
	{
		path: '/rentalcars/edit/:vehicleId',
		name: 'RentalCarEdit',
		component: RentalCarEdit,
	},
	{
		path: '/rentalcarcontractreturn/:contractId',
		name: 'RentalCarContractReturnForm',
		component: RentalCarContractReturnForm,
	},
	{
		path: '/rentalcarcontractreturn',
		name: 'rentalcarcontract.return',
		component: RentalCarContractReturn,
	},
	{
		path: '/rentalcarpricing/:companyId?',
		name: 'rentalcar.pricing',
		component: RentalCarPricing,
	},
];

export default routes;
